module.exports = __webpack_public_path__ + "static/media/payment2.c7af761d.svg";